import { useEffect, useState } from "react";

const useBufferSize = (bufferSize: number) => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--cardscan-buffer-max-size",
      bufferSize.toString()
    );
  }, [bufferSize]);

  //XXX NLS what is this?
  const bufferInfo = useState(4);

  return bufferInfo;
};

export default useBufferSize;
